import {createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";

const slice = createSlice({
    name: 'keywords',
    initialState: {
        lastDoc: null,
        keywords: [],
        raw: [],
        loading: false,
        error: null
    },
    reducers: {
        startLoading: (state) => {
            state.error = null;
            state.loading = true;
        },
        hasError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
            console.error(action.payload);
            toast.error("Une erreur s'est produite - keywords")
        },
        gotKeywords: (state, action) => {
            const {keywords, raw, lastDoc} = action.payload;

            state.error = null;
            state.loading = false;

            state.keywords = keywords;
            state.raw = raw;
            state.lastDoc = lastDoc;
        }
    }
});

export const {startLoading, hasError, gotKeywords} = slice.actions

const keywordsReducer = slice.reducer;

export default keywordsReducer;

export const selectKeyword = state => state.keywords